import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Product_Image from '../Product_Images/516823.jpg'
import MoneyIcon from '../Logos/money-alt-cash-currency.svg'
import CalenderIcon from '../Logos/calendar.svg'
import PencilIcon from '../Logos/pencil.svg'
import '../Style/Product.css'

// {"offer_percent": "10", "offered_price": "45000"}
function Product(Product_Data) {
    const [Colors, SetColors] = useState()
    const [Offer, SetOfferValues] = useState()
    useEffect(() => {
        SetColors(JSON.parse(Product_Data.Product_Data.colors))
        SetOfferValues(JSON.parse(Product_Data.Product_Data.offer))
    }, [])
    return (
        <>
            <Link to={Product_Data.Product_Data.link} className='product_com'>
                {Offer ? <div className='Offer-tag'>{Offer ? Offer.offer_percent : "N/A"}%</div> : null}
                <div className='product-image' style={{ backgroundImage: `url(${Product_Image})` }}></div>
                <div className='product-name'>{Product_Data.Product_Data && Product_Data.Product_Data.name ? Product_Data.Product_Data.name : "N/A"}</div>
                <div className='details'>
                    <div className='added-date'>
                        <div className='added-date-text'>تاریخ افزودن: {Product_Data.Product_Data && Product_Data.Product_Data.added_date ? Product_Data.Product_Data.added_date : "N/A"}</div>
                        <img src={CalenderIcon} className='calender-icon' />
                    </div>
                    <div className='updated-date'>
                        <div className='updated-date-text'>تاریخ بروزرسانی: {Product_Data.Product_Data && Product_Data.Product_Data.updated_date ? Product_Data.Product_Data.updated_date : "اخرین بروزرسانی وجود ندارد"}</div>
                        <img src={CalenderIcon} className='calender-icon' />
                    </div>
                    <div className='product-colors'>
                        <div className='title'>رنگ های موجود</div>
                        <div className='product-color-lister'>
                            {Colors ? Colors.map((Colors, Key) => {
                                return <div className='product-color' style={{ backgroundColor: `${Colors}` }}></div>
                            }) : "رنگی تعریف نشده است"}
                        </div>
                    </div>
                    {Product_Data.Product_Data && Product_Data.Product_Data.description ? <div className='description-container'>
                        <Link to={Product_Data.Product_Data.link} className='read-more'>ادامه...</Link>
                        <div className='description'>
                            {Product_Data.Product_Data && Product_Data.Product_Data.description ? Product_Data.Product_Data.description : "N/A"}
                        </div>
                        <img src={PencilIcon} className='pencil-icon' />
                    </div> : null}
                </div>
                <div className='price-container'>
                    <div className='price'>
                        {Product_Data.Product_Data.number <= 0 ? <div className='out-of-number-container'>
                            <div className='wrapper'></div>
                            <div className='text'>ناموجود</div>
                        </div> : Offer ? <><div className='offered-price'>
                            <div className='offer-price'>{Offer.offered_price}</div>
                        </div>
                            <i class="icony icony-toman"></i>
                            <div className={Offer && Product_Data.Product_Data.number != 0 ? "last-price" : "price-text"}>
                                {Product_Data.Product_Data && Product_Data.Product_Data.price ? Product_Data.Product_Data.price : "N/A"}
                                </div></> :
                            <>
                                <i class="icony icony-toman"></i>
                                <div className={Offer && Product_Data.Product_Data.number != 0 ? "last-price" : "price-text"}>
                                    {Product_Data.Product_Data && Product_Data.Product_Data.price ? Product_Data.Product_Data.price : "N/A"}</div></>}
                        {/* <div className='offered-price'> {Offer.offered_price} تومان</div> */}
                        {/* <img src={MoneyIcon} className='money-icon' /> */}
                        {/* <div className={Offer && Product_Data.Product_Data.number != 0 ? "last-price" : "price-text"}>{Product_Data.Product_Data && Product_Data.Product_Data.price ? Product_Data.Product_Data.price : "N/A"} تومان</div> */}
                    </div>
                </div>
            </Link>
        </>
    )
}

export default Product